import styled from 'styled-components';

export const ShareModuleWrapper = styled.div`
    display: flex;
    border-radius: 30px;
    justify-content: center;
    align-items: center;

    @media (min-width: ${({ theme }) => theme?.breakpoints.mobile}) {
        padding: 9px 10px 9px 25px;
        background: ${({ theme }) => theme?.shades.white['10']};
    }

    .copy-module__icon-button,
    .open-yat-button {
        background: transparent;
    }
`;

export const YatWrapper = styled.div`
    font-size: 16px;
    line-height: 16px;
    height: 16px;
    align-items: center;
    display: flex;
    flex-direction: row;

    @media (max-width: ${({ theme }) => theme?.breakpoints.mobile}) {
        display: none;
    }
`;

export const YatButtonsWrapper = styled.div`
    .copy-module {
        z-index: 1;
    }
    @media (max-width: ${({ theme }) => theme?.breakpoints.mobile}) {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        height: 32px;
        width: 32px;
        background: ${({ theme }) => theme?.shades.white['10']};
        margin-left: 5px;

        .copy-module__icon-button {
            width: 28px;
            padding: 4px;
        }
        .open-yat-button {
            padding: 2px;
        }
    }
`;
